import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=aea0d49a&scoped=true&"
import script from "./AuthCallback.vue?vue&type=script&lang=ts&"
export * from "./AuthCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea0d49a",
  null
  
)

export default component.exports